import React from "react";
import cardScreen from "../../images/cashbach/Bankscreen-Cards.png";
import { LoginStyles } from "./Login.styled";
import { useHistory } from "react-router-dom";

const CardPage = () => {
  const history = useHistory();
  return (
    <LoginStyles>
      <div className="images-section-div">
        <img src={cardScreen} alt="login-screen" className="login-screen" />
        <button
          className="transparent-btn-c"
          aria-label="Click"
          onClick={() => {
            history.push("/Home");
          }}
        >

        </button>
      </div>
    </LoginStyles>
  );
};
export default CardPage;
